import { StepperSelectionEvent, STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { ClientService } from '@core/services/client/client.service';
import { RoleEnum } from '@core/services/role/role.model';

const PAGE_TITLE: string = 'Add Client';

@Component({
  selector: 'Teranet-ClientStepper',
  templateUrl: './client-stepper.component.html',
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})

export class ClientStepperComponent implements OnInit {
  @Input() clientInfoId: number;
  @Input() Readonly: boolean;
  @Output('selectStepper')
  isLinear = true;
  isNew = true;
  outputHasValue = false;
  pageTitle: string = PAGE_TITLE;
  selectStepperChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private authService: AuthService,
    private clientService: ClientService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.clientService.isClientChanged$.subscribe(value => {
      if (value && typeof value === 'number' && value >= 0) {
        this.clientInfoId = value as number;
      }
    });

    this.clientService.isTitleChanged$.subscribe(value => {
      if (value) {
        this.pageTitle = value as string;
      }
    })
  }

  ngOnInit() {
    this.refresh();
  }

  getUrlWithoutParams() {
    let urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = {};
    urlTree.fragment = null;
    return urlTree.toString();
  }

  goToClient() {
    this.router.navigateByUrl('/clientinfo');
  }

  refresh() {
    if (this.authService.currentUserValue.role.toLowerCase().trim() == RoleEnum.administrator) {
      this.Readonly = false;
    }
    else {
      this.Readonly = true;
    }

    this.route.queryParams.subscribe(value => {
      if (value) {
        if (value['id'] as number >= 0) {
          this.clientInfoId = value['id'] as number;
          this.isLinear = false;
          this.isNew = false;
          this.pageTitle = 'Manage Client | ' + value['title'];
        }
        else {
          this.clientInfoId = -1;
          this.isNew = true;
          this.pageTitle = PAGE_TITLE;
        }
      }
    });
  }

  selectionChange(event: StepperSelectionEvent) {
    this.selectStepperChange.emit(event.selectedStep.label);
  }
}
